module.exports = __webpack_public_path__ + "media/images/lp_ex-c98d24fa7c011dda45c2d8ddf5f67f4e.webp";